import { render } from "./supportTicketOverview.vue?vue&type=template&id=1166bdda&scoped=true&ts=true"
import script from "./supportTicketOverview.vue?vue&type=script&lang=ts"
export * from "./supportTicketOverview.vue?vue&type=script&lang=ts"

import "./supportTicketOverview.vue?vue&type=style&index=0&id=1166bdda&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1166bdda"]])

export default __exports__